export type BeforeInstallPromptUserChoice = {
  outcome: "accepted" | "dismissed";
  platform: string;
};

// This event is still not part of the standard TS DOM lib in many setups.
// We keep it local + minimal to avoid leaking `any` into the UI layer.
export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<BeforeInstallPromptUserChoice>;
};

type WindowLike = {
  matchMedia?: (query: string) => { matches: boolean };
  navigator?: Navigator & { standalone?: boolean };
};

export function isStandaloneDisplayMode(win: WindowLike): boolean {
  // Most platforms: display-mode media query.
  if (win.matchMedia?.("(display-mode: standalone)")?.matches) return true;
  // iOS Safari (legacy): navigator.standalone.
  if (win.navigator?.standalone) return true;
  return false;
}
